"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.to-string");
var _auth = require("@/utils/auth");
var _Identify = _interopRequireDefault(require("@/components/Identify"));
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { JSEncrypt } from 'jsencrypt'
var _default = exports.default = {
  name: 'AccountLogin',
  components: {
    Identify: _Identify.default
  },
  data: function data() {
    var _this = this;
    var validateUsername = function validateUsername(rule, value, callback) {
      if (value.length < 1) {
        callback(new Error(_this.$t('login.error.username')));
      } else if (_this.errorKeys.indexOf('loginCode') >= 0) {
        callback(new Error(_this.errorInfo['loginCode']));
      } else {
        callback();
      }
    };
    var validatePassword = function validatePassword(rule, value, callback) {
      if (!value || value.length < 6) {
        callback(new Error(_this.$t('login.error.password')));
      } else if (_this.errorKeys.indexOf('loginPass') >= 0) {
        callback(new Error(_this.errorInfo['loginPass']));
      } else {
        callback();
      }
    };
    var validateIdentifyCode = function validateIdentifyCode(rule, value, callback) {
      if (!value || value !== _this.identifyCode) {
        callback(new Error(_this.$t('login.error.code')));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        username: '',
        password: '',
        identifyCode: ''
      },
      loginRules: {
        username: [{
          required: false,
          trigger: ['change'],
          validator: validateUsername
        }],
        password: [{
          required: false,
          trigger: ['change'],
          validator: validatePassword
        }],
        identifyCode: [{
          required: false,
          trigger: ['blur'],
          validator: validateIdentifyCode
        }]
      },
      isSelectRoles: false,
      role: '',
      roleList: [],
      token: '',
      sasToken: '',
      errorKeys: [],
      errorInfo: {},
      passwordType: 'password',
      identifyCode: '',
      identifyCodes: '0123456789',
      isRemember: '',
      loading: false
    };
  },
  mounted: function mounted() {
    this.eventInit();
    this.refreshCode(); // 生成验证码
  },
  methods: {
    getRoleName: _index.getRoleName,
    eventInit: function eventInit() {
      // focus当前输入项
      if (this.loginForm.username === '') {
        this.$refs.username.focus();
      } else if (this.loginForm.password === '') {
        this.$refs.password.focus();
      }
      // 确认并获取账号密码状态
      this.isRemember = localStorage.getItem('isRemember') ? localStorage.getItem('isRemember') : '';
      if (this.isRemember) {
        this.loginForm.username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
        this.loginForm.password = localStorage.getItem('password') ? this.decryptStr(localStorage.getItem('password'), 'local') : '';
      }
    },
    showPwd: function showPwd() {
      var _this2 = this;
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
      this.$nextTick(function () {
        _this2.$refs.password.focus();
      });
    },
    clickRadio: function clickRadio() {
      this.isRemember = this.isRemember ? '' : 'y';
    },
    encryptStr: function encryptStr(password) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'login';
      var NodeRSA = require('node-rsa');
      var a_public_key_data = type === 'login' ? process.env.VUE_APP_PUBLIC_KEY : process.env.VUE_APP_PWD_PUB_KEY;
      var key = new NodeRSA();
      key.setOptions({
        encryptionScheme: 'pkcs1'
      });
      key.importKey(a_public_key_data, 'pkcs8-public');
      var x = key.encrypt(password, 'base64');
      return x;
    },
    decryptStr: function decryptStr(password) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'login';
      var NodeRSA = require('node-rsa');
      var a_private_key_data = type === 'login' ? process.env.VUE_APP_PRIVATE_KEY : process.env.VUE_APP_PWD_PRI_KEY;
      var key2 = new NodeRSA();
      key2.setOptions({
        encryptionScheme: 'pkcs1'
      });
      key2.importKey(a_private_key_data, 'pkcs8-private');
      var y = key2.decrypt(password, 'utf8');
      return y;
    },
    handleLogin: function handleLogin() {
      var _this3 = this;
      this.errorKeys = [];
      this.errorInfo = {};
      this.$refs['loginForm'].clearValidate();
      this.$refs.loginForm.validate(function (valid) {
        if (!valid) return;
        _this3.loading = true;
        var _this3$loginForm = _this3.loginForm,
          username = _this3$loginForm.username,
          password = _this3$loginForm.password;
        console.log(username, password);
        // const data = { loginCode: username.trim(), loginPass: password }
        // const encData = {
        //   sdata: this.encryptStr(data)
        // }
        _this3.$api.login.sfeLogin({
          loginCode: username.trim(),
          loginPass: _this3.encryptStr(password),
          loginBizType: 'SFE',
          loginType: 'EMAIL',
          loginPlatform: 'PC',
          mApiLevel: 'y7ollu',
          mBrand: 's57x60',
          mApplicationName: 'milford.prosacco',
          mBuildNumber: '6y5am0',
          mBundleId: '37',
          mCarrier: 'g568u4',
          mDeviceCountry: 'kjxc52',
          mDeviceId: '37',
          mDeviceLocale: 'jevqv8',
          mDeviceName: 'milford.prosacco',
          mFirstInstallTime: '2023-05-31 07:55:07',
          mLastUpdateTime: '2023-05-31 07:55:07',
          mMacAddress: '1188 Hegmann View， East Janeenville， VT 24648',
          mManufacturer: 'ho1lvd',
          mReadableVersion: '0.65',
          mSerialNumber: 'ab4ob2',
          mSystemName: 'milford.prosacco',
          mSystemVersion: '0.65',
          mTimeZone: '9tnvjm',
          mUniqueId: '37',
          mUserAgent: 's8s57v',
          mVersion: '0.65',
          mIsTablet: 'yppmha',
          beginTime: '2023-05-31 07:55:07'
        })
        // this.$api.login.getAuthToken(encData)
        .then(function (res) {
          localStorage.setItem('isRemember', _this3.isRemember);
          if (_this3.isRemember) {
            localStorage.setItem('username', username);
            localStorage.setItem('password', _this3.encryptStr(password, 'local'));
          } else {
            localStorage.removeItem('username');
            localStorage.removeItem('password');
          }
          _this3.token = res.data.token;
          _this3.sasToken = res.data.sasToken;
          var expiredTime = (new Date().getTime() + 15 * 60 * 1000).toString();
          _this3.$store.dispatch('user/setSasTokenExpiredTime', expiredTime);
          _this3.$store.dispatch('user/setInfo', res.data);
          _this3.$store.dispatch('user/setSystemList', [{
            systemName: 'SFE管理后台',
            appIdentification: 'sfe'
          }]);
          _this3.currentSystem = {
            systemName: 'SFE管理后台',
            appIdentification: 'sfe'
          };
          _this3.role = res.data.roleCodes[0];
          _this3.roleList = res.data.roleCodes;
          if (res.data.roleCodes.length === 1) {
            _this3.changeRole();
          } else {
            // 弹框提示选择角色
            _this3.isSelectRoles = true;
          }
          _this3.loading = false;
        }).catch(function () {
          // if (err.errorInfos && err.errorInfos.length > 0) {
          //   err.errorInfos.forEach(item => {
          //     this.errorKeys.push(item.key)
          //     this.errorInfo[item.key] = item.errMsg
          //   })

          //   this.$refs['loginForm'].validate(valid => {
          //   })
          // }
          _this3.$message.error(_this3.$t('errorMsg.loginFail'));
          _this3.loading = false;
        });
      });
    },
    backToLogin: function backToLogin() {
      this.isSelectRoles = false;
      (0, _auth.removeToken)();
      this.$router.push({
        path: '/login'
      });
    },
    changeRole: function changeRole() {
      var _this4 = this;
      var param = {
        roleCode: this.role
      };
      if (this.role == "Leadership") {
        this.$message.error(this.$t('navbar.changeRole_noPermission'));
        return;
      }
      this.$api.login.sfeChangeRole(param, this.token).then(function (res) {
        if (res.data.menus && res.data.menus.length) {
          // 有菜单可以访问
          _this4.$store.dispatch('user/setRoles', [_this4.role]);
          _this4.$store.dispatch('user/setTeamType', res.data.teamType);
          _this4.$store.dispatch('user/setToken', _this4.token);
          _this4.$store.dispatch('user/setSasToken', _this4.sasToken);
          _this4.$store.dispatch('user/setCurrentSystemInfo', _this4.currentSystem);
          _this4.$store.dispatch('nocache/setAddRoute', {
            isAddRoute: true
          });
          _this4.$store.dispatch('permission/generateRoutes', res.data.menus).then(function (res) {
            _this4.$router.push({
              path: '/dashboard'
            });
          });
          _this4.$store.dispatch('permission/generateFunctions', res.data.functions);
        } else {
          // 没有菜单可以访问
          _this4.$message.error(_this4.$t('navbar.changeRole_noPermission'));
        }
      });
    },
    refreshCode: function refreshCode() {
      this.loginForm.identifyCode = '';
      this.identifyCode = '';
      this.makeCode(this.identifyCodes, 4);
    },
    randomNum: function randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    makeCode: function makeCode(o, l) {
      for (var i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
    }
  }
};